import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { contextTheme } from "../contexts/ProviderTheme";
import { contextProvider } from "../Providers";

export default function Navigation() {
  let navigate = useNavigate();
  const { theme } = useContext(contextTheme);
  const { setFilterCategory, categories } = useContext(contextProvider);

  const styles = {
    color: !theme ? "#333" : "#FFF",
  };

  const filterByCategory = (id) => {
    setFilterCategory(id);
    document.querySelector('.nav-menu').classList.toggle('show');
    return navigate("/");
  };

  return (
    <ul className="nav-menu">
      {categories.map( c => (
        <li key={c._id}><a style={styles}
        onClick={() => filterByCategory(c._id)}>{c.title}
          </a></li>
      ))}

      <li>
        <a
          style={styles}
          onClick={() => {
            setFilterCategory('');
            document.querySelector('.nav-menu').classList.toggle('show');
            
          }}
        >
          All Products
        </a>
      </li>

      <li>
        <a rel="noreferrer" target="_blank" href="https://pancakeswap.finance/swap">Buy $STORE</a>
      </li>
    </ul>
  );
}
